import { atom } from 'recoil';

export const selectWorkId = atom({
  key: 'workId',
  default: 0,
});
